/**
 * Content Management Router
 * Routes to different content management sections
 */

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ChapterCreation from './ChapterCreation';
import QuestCreation from './QuestCreation';
import LegacyQuests from './LegacyQuests';
import DailyInspirations from './DailyInspirations';
import AIStylesManagement from '../ai/AIStylesManagement';
import AIMoodsManagement from '../ai/AIMoodsManagement';
import PDFTemplateManagement from './PDFTemplateManagement';

export const ContentManagement: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="chapter-creation" replace />} />
      <Route path="chapter-creation" element={<ChapterCreation />} />
      <Route path="chapters" element={<ChapterCreation />} />
      <Route path="quest-creation" element={<QuestCreation />} />
      <Route path="quests" element={<QuestCreation />} />
      <Route path="legacy-quests" element={<LegacyQuests />} />
      <Route path="daily-inspirations" element={<DailyInspirations />} />
      <Route path="ai-styles" element={<AIStylesManagement />} />
      <Route path="ai-moods" element={<AIMoodsManagement />} />
      <Route path="pdf-templates" element={<PDFTemplateManagement />} />
    </Routes>
  );
};

export default ContentManagement;